import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "black",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.73237 0.907777C5.81104 0.640958 6.18896 0.640959 6.26763 0.907777L7.32316 4.48811C7.34995 4.57898 7.42102 4.65005 7.51189 4.67684L11.0922 5.73237C11.359 5.81104 11.359 6.18896 11.0922 6.26763L7.51189 7.32316C7.42102 7.34995 7.34995 7.42102 7.32316 7.51189L6.26763 11.0922C6.18896 11.359 5.81104 11.359 5.73237 11.0922L4.67684 7.51189C4.65005 7.42102 4.57898 7.34995 4.48811 7.32316L0.907777 6.26763C0.640958 6.18896 0.640959 5.81104 0.907777 5.73237L4.48811 4.67684C4.57898 4.65005 4.65005 4.57898 4.67684 4.48811L5.73237 0.907777Z" })
});
export default SvgStar;
